import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "w-5 h-5" }

import type { ListProps } from "./ListProps.ts";
import EditableElement from "@/views/page/EditableElement.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    blockId: {},
    items: {},
    textColor: {},
    checkmarkColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createBlock(EditableElement, {
        key: item.id,
        blockId: _ctx.blockId,
        "field-name": `listItems_${item.id}`,
        hideable: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                style: _normalizeStyle({ color: _ctx.checkmarkColor })
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  d: "M18.3346 10.0003C18.3346 5.39795 14.6036 1.66699 10.0013 1.66699C5.39893 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39893 18.3337 10.0013 18.3337C14.6036 18.3337 18.3346 14.6027 18.3346 10.0003Z",
                  fill: "currentColor",
                  stroke: "currentColor",
                  "stroke-width": "1.25"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M6.66797 10.4167L8.7513 12.5L13.3346 7.5",
                  stroke: "white",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]), 4))
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.textColor })
            }, _toDisplayString(item.text), 5)
          ])
        ]),
        _: 2
      }, 1032, ["blockId", "field-name"]))
    }), 128))
  ]))
}
}

})